module.exports = __webpack_public_path__ + "img/fuzzy@2x.712e2303.png";